<div fxLayout="row" class="line" style="height: 100%; width: 100%">
   <div
      fxLayout="column"
      fxFlex="1 1 100"
      class="info"
      *ngIf="!(isLineBIdle$ | async)"
      [ngClass]="{
         hold: isLineBOnHold$ | async
      }"
   >
      <div
         fxFlex="1 1 80"
         [ngClass]="{
            holdtext: isLineBOnHold$ | async
         }"
      >
         <div fxFlex="100" fxLayout="column" *ngIf="currentDestinationLineStateModel$ | async; let lineInfo">
            <div class="skill">&nbsp;</div>
            <div fxFlex="1 1 90" fxLayout="column" class="large-view">
               <div fxFlex="1 1 60" class="avatar avatar-connected">
                  <samweb-avatar
                     class="sam-padding"
                     [dn]="lineInfo.dn"
                     [useSamwinShape]="false"
                     [useRoundShape]="true"
                     [showPresenceStatus]="false"
                     fxFlex="0 0 100"
                     *ngIf="lineInfo.dn !== ''"
                  >
                  </samweb-avatar>
               </div>
               <div fxFlex="1 1 40" class="lineInfo" *ngIf="lineInfo">
                  <div *ngIf="lineInfo.dn | isAnonymous" class="container" fxFlex="1 1 auto">
                     <div class="line-name">
                        {{ 'common.calling.unknown_number' | translate }}
                     </div>
                  </div>
                  <div *ngIf="!(lineInfo.dn | isAnonymous) && lineInfo.dn !== ''" fxLayout="column" class="container">
                     <div *ngIf="lineInfo.name !== ''" class="line-name">
                        {{ lineInfo.name }}
                     </div>
                     <div *ngIf="lineInfo.dn !== ''" fxFlex="1 1 auto" class="container">
                        <div [class.line-name]="lineInfo.peerName === ''">
                           {{ lineInfo.dn }}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div fxFlex="20" class="line-buttons" fxLayout="row">
         <div class="button-container">
            <button
               class="content dial-control dial-control-transfer"
               kendoButton
               (click)="transferCall()"
               [disabled]="!(canTransfer$ | async) && !(canDisconnectLineB$ | async)"
            >
               <div class="fa-layers">
                  <fa-icon [icon]="transferIcon"></fa-icon>
               </div>
            </button>
         </div>
         <div class="button-container">
            <button
               class="content dial-control dial-control-hang-up"
               kendoButton
               (click)="disconnectLineB()"
               [disabled]="!(canDisconnectLineB$ | async)"
            >
               <div class="fa-layers">
                  <fa-icon [icon]="hangUpIcon"></fa-icon>
               </div>
            </button>
         </div>
         <div class="button-container">
            <button
               class="content dial-control dial-control-hold"
               kendoButton
               (click)="holdLine()"
               [disabled]="!(canToggleHoldLineB$ | async)"
               [ngClass]="{ hold: isLineBOnHold$ | async }"
            >
               <div class="fa-layers">
                  <fa-icon [icon]="holdIcon"></fa-icon>
               </div>
            </button>
         </div>
      </div>
   </div>
</div>
